//对axios进行二次封装( 实例化axios对象, 设置请求拦截器, 设置响应拦截器 )

import axios from "axios";
import { Toast } from "antd-mobile";
//实例化axios对象
var service = axios.create({
  baseURL: process.env.REACT_APP_ENV === "production" ? process.env.REACT_APP_BASE_URL: "http://api.xiejiuhe.com/",
  // baseURL: process.env.REACT_APP_ENV === "production" ? process.env.REACT_APP_BASE_URL: "http://localhost:92/",
  // baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 10 * 1000, //超时时间
});
console.log('当前环境:',process.env.REACT_APP_ENV,process.env.REACT_APP_BASE_URL,process.env) 
//设置请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    const sso = localStorage.getItem("SSO-TOKEN");
    const company = localStorage.getItem("companyid");
    const project = localStorage.getItem("projectID");
    // if (token) {
      // if (config && config?.headers) {
        config.headers["Authorization"] = "Bearer" + " " + token;
        config.headers["SSO-TOKEN"] = sso
        config.headers["Company-Id"] = company;
        config.headers["Project-Id"] = project;
      // }
    // }
    return config;
  },

  (err) => {
    return Promise.reject(err);
  }
);

//设置响应拦截器
service.interceptors.response.use(
  (res) => {
    if (res.data.code == 401) {
      Toast.show({
        icon: "fail",
        content: "身份验证失败,登陆过期,请重新登录",
      });
      window.location.href='http://'+window.location.host+'/login'
    } else if (res.data.code == -1) {
      Toast.show({
        icon: "fail",
        content: res.data.msg,
      });
    } else if (res.data.code == 500) {
      Toast.show({
        icon: "fail",
        content: "服务器内部错误!",
      });
    }
    return res;
  },

  (err) => {
    Toast.show({
      icon: "fail",
      content: "服务器内部错误!",
    });

    return Promise.reject(err);
  }
);

export default service;
